import React, { createContext, useEffect, useRef, useState } from 'react';
import api from '../services/api';
export const MarkContext = createContext({});

function MarksProvider({ children }) {

    const [marks,setMarks] = useState([])
    const [descriptionData,setDescription] = useState()

    const getAll = async () => {
        const response = await api.get("panel/get/all/categorys")

        if(response.status == 200){
            setMarks(response.data)
        }

    }
    

    useEffect(() => {

        getAll()
    },[])


    return (
        <MarkContext.Provider value={{getAll,marks,setDescription,descriptionData}}>
            {children}
        </MarkContext.Provider>
    );
}

export default MarksProvider;
